import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { TruthSection } from '../components/TruthSection';
import { ProductSection } from '../components/ProductSection';
import { TomesSection } from '../components/TomesSection';
import { BonusSection } from '../components/BonusSection';
import { TransformationTable } from '../components/TransformationTable';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { UpsellSection } from '../components/UpsellSection';
import { PricingSection } from '../components/PricingSection';
import { FinalCTA } from '../components/FinalCTA';
export function SalesPage() {
  return <main className="min-h-screen bg-warm-cream font-body text-text-body overflow-x-hidden" data-id="element-342">
      <HeroSection data-id="element-343" />
      <ProblemSection data-id="element-344" />
      <TruthSection data-id="element-345" />
      <ProductSection data-id="element-346" />
      <TomesSection data-id="element-347" />
      <BonusSection data-id="element-348" />
      <TransformationTable data-id="element-349" />
      <TestimonialsSection data-id="element-350" />
      <UpsellSection data-id="element-351" />
      <PricingSection data-id="element-352" />
      <FinalCTA data-id="element-353" />
    </main>;
}